/**
 * SuperOps embedded mode detection utilities
 * Minimal utilities for detecting iframe/embedded mode
 */

/**
 * Check if the app is running inside an iframe
 * @returns true if in iframe context
 */
export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (error) {
    // if throws error on accessing parent, it is in iframe
    console.error(error);
    return true;
  }
};

/**
 * Check if the app is currently running in embedded mode
 * @returns true if in iframe OR has embed=true query parameter
 */
export const isEmbedded = (): boolean => {
  // Check if running in iframe
  const inIframe = isInIframe();

  // Check for embed query parameter
  const urlParams = new URLSearchParams(window.location.search);
  const embedParam = urlParams.get('embed') === 'true';

  return inIframe || embedParam;
};

/**
 * Check if add entity actions (Add Client/Add Contact buttons) should be shown
 * Returns false when in SuperOps embedded mode to hide these actions
 * @returns true if add entity actions should be shown, false if they should be hidden
 */
export const shouldShowAddEntityActions = (): boolean => {
  return !isEmbedded();
};